// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__q+gqn","tab-active":"tab_tab-active__DT4Qh"};